<template>
  <ul class="publisher-counters__wrapper">
    <li>{{ articlesCount }} {{ articleCountText }}</li>
    <li v-if="followersCount">{{ followersCount }} {{ followersCountText }}</li>
  </ul>
</template>
<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'

export default {
  name: 'PublisherCounters',
  props: {
    articlesCount: propValidator([PROP_TYPES.NUMBER], false, 0),
    followersCount: propValidator([PROP_TYPES.NUMBER], false, 0)
  },
  computed: {
    articleCountText() {
      return this.articlesCount === 1 ? 'Article' : 'Articles'
    },
    followersCountText() {
      return this.followersCount === 1 ? 'Follower' : 'Followers'
    }
  }
}
</script>

<style scoped lang="scss">
.publisher-counters__wrapper {
  li {
    line-height: 18px;
    font-weight: 600;

    $font-size: (
      $above-desktop-xl: 16px,
      $mobile: 13px
    );

    @include setStyleByBreakpoint('font-size', $font-size);
  }
}
</style>
